// Doctor-finder / appointment dates are formatted with moment.js. The npm moment
// build ships English only, so we bundle the locales we translate the site into
// and set moment's global locale from the active locale: the `?locale=` param,
// then the server-resolved locale (SparkleConfig, or `window.Sparkle.locale` in
// an embed), then `<html lang>` (correct when Sparkle renders standalone).
// (`ht` is a hand-authored locale under app/assets — moment ships none.)
//
// The locales come from `moment/dist/locale`, whose modules import
// `moment/dist/moment.js`, the build `vite.config.ts` pins `moment` to, so they
// register on the moment the finder formats with.
import moment from "moment";
import "moment/dist/locale/es";
import "moment/dist/locale/pt-br";
import "moment/dist/locale/fr";
import "moment/dist/locale/ar";
import "moment/dist/locale/zh-cn";
import "./moment_locales/ht.js";

const MOMENT_LOCALE = { es: "es", pt: "pt-br", fr: "fr", ar: "ar", "zh-CN": "zh-cn", ht: "ht" };

// Each locale module calls `moment.defineLocale`, which SETS the global locale
// to the locale it just defined — so after the imports, moment's global locale
// is `ht` (the last one imported), NOT English. Always set the locale
// explicitly, falling back to `en`, so an English page resets moment to English
// instead of inheriting that side effect.
try {
  const requested =
    new URL(window.location.href).searchParams.get("locale") ||
    window.SparkleConfig?.locales?.current ||
    window.Sparkle?.locale ||
    document.documentElement.lang;
  moment.locale((requested && MOMENT_LOCALE[requested]) || "en");
} catch {
  moment.locale("en");
}
